import InvoiceService from '../../services/InvoiceService';

import * as types from './types';
import {
  dispatchNetworkRequest,
  dispatchNetworkRequestDynamicSuccessDispatch,
} from '../networkDispatcher';

export const getInvoices = (barnUserIds, status, startDate, endDate, page = 0, pageSize = 25, sort = '') => (dispatch) => {
  const promise = InvoiceService.getInvoices(barnUserIds, status, startDate, endDate, page, pageSize, sort);
  dispatchNetworkRequest({
    dispatch,
    requestType: types.GET_INVOICES_REQUESTED,
    successType: types.GET_INVOICES_SUCCESS,
    errorType: types.GET_INVOICES_ERROR,
    promise,
    defaultErrorMessage: 'There was a problem loading invoices for this organization',
    responseName: 'invoices',
  });
  return promise;
};

export const getInvoice = (id, includeToken = true) => (dispatch) => {
  const promise = InvoiceService.getInvoice(id, includeToken);
  dispatchNetworkRequest({
    dispatch,
    requestType: types.GET_INVOICE_REQUESTED,
    successType: types.GET_INVOICE_SUCCESS,
    errorType: types.GET_INVOICE_ERROR,
    promise,
    defaultErrorMessage: 'There was a problem loading invoice for this organization',
    responseName: 'invoice',
  });
  return promise;
};
export const getInvoicePdf = (id) => (dispatch) => {
  const promise = InvoiceService.getInvoicePdf(id);
  dispatchNetworkRequestDynamicSuccessDispatch({
    dispatch,
    requestType: types.GET_INVOICE_PDF_REQUESTED,
    errorType: types.GET_INVOICE_PDF_ERROR,
    successDispatch: {
      type: types.GET_INVOICE_PDF_SUCCESS,
      fileName: `invoice-${id}.pdf`,
    },
    promise,
    defaultErrorMessage: 'There was a problem downloading invoice PDF for this organization',
    responseName: 'download',
  });
  return promise;
};

export const addInvoice = (request) => (dispatch) => {
  const promise = InvoiceService.postInvoice(request);
  dispatchNetworkRequest({
    dispatch,
    requestType: types.ADD_INVOICES_REQUESTED,
    successType: types.ADD_INVOICES_SUCCESS,
    errorType: types.ADD_INVOICES_ERROR,
    promise,
    successMessage: 'Successfully created the invoice',
    defaultErrorMessage: 'There was a problem adding the invoice to the horse',
    responseName: 'newInvoice',
  });
  return promise;
};

export const updateInvoice = (id, request) => (dispatch) => {
  const promise = InvoiceService.updateInvoice(id, request);
  dispatchNetworkRequest({
    dispatch,
    requestType: types.UPDATE_INVOICES_REQUESTED,
    successType: types.UPDATE_INVOICES_SUCCESS,
    errorType: types.UPDATE_INVOICES_ERROR,
    promise,
    successMessage: 'Successfully updated the invoice',
    defaultErrorMessage: 'There was a problem updating the invoice',
    responseName: 'updatedInvoice',
  });
  return promise;
};

export const deleteInvoice = (id) => (dispatch) => {
  const promise = InvoiceService.deleteInvoice(id);
  dispatchNetworkRequestDynamicSuccessDispatch({
    dispatch,
    requestType: types.DELETE_INVOICES_REQUESTED,
    successDispatch: {
      type: types.DELETE_INVOICES_SUCCESS,
      deletedInvoiceId: id,
    },
    errorType: types.DELETE_INVOICES_ERROR,
    promise,
    successMessage: 'Successfully deleted the invoice',
    defaultErrorMessage: 'There was a problem deleting the invoice',
    responseName: 'response',
  });
  return promise;
};
